import { theme, darkTheme } from "@compass/core";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import ImageResize from "quill-image-resize-module-react";
import { createRoot } from "react-dom/client";
import { Provider, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { RootState, store } from "redux/store";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Quill } from "react-quill";

import "css/devextreme-fix.css";
import "css/devextreme.css";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";

import "react-quill/dist/quill.snow.css";

import * as Sentry from "@sentry/react";

var Block = Quill.import("blots/block") as any;
(Block as any).tagName = "DIV";
Quill.register("modules/imageResize", ImageResize); // register Quill's ability to resie image
Quill.register(Block, true); // register Quill's output to use <div> instead of <p> as blocks

Sentry.init({
  dsn: "https://ddbbdf842c95af6fecf23e2fa750a9b3@o4510003962642432.ingest.us.sentry.io/4510006326525952",
  environment: process.env.REACT_APP_ENV,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    })
  ],
  // Session Replay
  replaysSessionSampleRate: 0.05, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

function ThemedApp() {
  const mode = useSelector((state: RootState) => state.app.theme);
  const activeTheme = mode === "Dark" ? darkTheme : theme;

  return (
    <ThemeProvider theme={activeTheme}>
      <BrowserRouter>
        <CssBaseline />
        <App />
      </BrowserRouter>
    </ThemeProvider>
  );
}

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  //<React.StrictMode> // this triggers useEffect component on mount twice
  <Provider store={store}>
    <ThemedApp />
  </Provider>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
